import type { ApiEventImportedType } from 'modules/listing/api/volop/types/ApiEventImportedType';

export const EVENT_IMPORTED_TYPE_MAP: Record<ApiEventImportedType, string> = {
  NYCPARKS: 'NYC Parks',
  CITIZENCONNECT: 'Citizen Connect',
};
